import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 224,
	height: 114,
	fill: "none",
	viewBox: "0 0 224 114",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			className: "animate-spin",
			style: {
				transformOrigin: "67% 50%",
				animationDuration: "30s"
			},
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFCA64",
					d: "M180.84 56.9a30.94 30.94 0 1 1-61.89 0 30.94 30.94 0 0 1 61.9 0Z"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 198.66,
					cy: 56.91,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(90 198.66 56.9)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 190.77,
					cy: 83.86,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(122.68 190.77 83.86)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 169.5,
					cy: 102.31,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(155.37 169.5 102.31)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 141.49,
					cy: 106.29,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-171.84 141.49 106.3)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 115.95,
					cy: 94.52,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-138.96 115.95 94.52)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 100.83,
					cy: 70.87,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-106.25 100.83 70.87)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 100.93,
					cy: 42.59,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-73.32 100.93 42.59)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 116.21,
					cy: 19.07,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-40.63 116.21 19.07)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 141.94,
					cy: 7.46,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(-7.73 141.94 7.46)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 169.75,
					cy: 11.62,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(25.06 169.75 11.62)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 190.96,
					cy: 30.25,
					fill: "#FFCA64",
					rx: 3.99,
					ry: 6.99,
					transform: "rotate(57.74 190.96 30.25)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			fillRule: "evenodd",
			d: "M203 110H14.95A29.54 29.54 0 0 1 48.5 73.42a46.52 46.52 0 0 1 90.21 9.87 18.5 18.5 0 0 1 23.02 8.33 18.53 18.53 0 0 1 19.75 7.02A13.5 13.5 0 0 1 202.99 110Z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 224,
			height: 4,
			fill: "#fff",
			rx: 2,
			transform: "matrix(-1 0 0 1 224 110)"
		})
	]
});
const SvgSunCloud = styled(base)({});
export default SvgSunCloud;
